import {
  VpnKey,
  List as ListIcon,
  Event,
  CloudDone,
  CloudQueue,
  Link as LinkIcon,
  TextFormat,
  LooksOne,
  Add,
} from '@mui/icons-material'
import { GovernanceType } from '@global/types'
import AiCreativeIcon from 'images/ai-creative.svg'

interface Props {
  governanceType: GovernanceType
}

export const ReadGridHeaderIcon = ({ governanceType }: Props) => {
  const Icon = getIcon(governanceType)

  return (
    <Icon
      fontSize="small"
      color="disabled"
      style={{ width: '17px', height: '17px', color: 'rgba(0, 0, 0, 0.26)' }}
    />
  )
}

function getIcon(type: GovernanceType) {
  switch (type) {
    case 'cv_id':
    case 'pattern':
      return VpnKey
    case 'date':
      return Event
    case 'deep-link':
    case 'qr-code':
    case 'shortened link':
    case 'autofill':
    case 'custom-bitlink':
      return LinkIcon
    case 'link-validation':
      return CloudDone
    case 'autonumber':
      return LooksOne
    case 'concatenation':
      return Add
    case 'link':
      return CloudQueue
    case 'list':
      return ListIcon
    case 'creative':
      return AiCreativeIcon
    default:
      return TextFormat
  }
}
